import { Box } from '@vouched.id/vault';
import React, { useMemo } from 'react';
import { Tooltips } from '../../tooltips';
import { itemHasErrorOrWarning } from '../../utils';
import { Dropdown } from '../Dropdown';
import { DropdownItemsSection } from '../DropdownItemsSection';
import { buildDeviceData, buildExtractedData, buildSubmittedData, IDVDetailsTable } from '../IdDocument/IDVDetailsTable';
import { addIconsToDropdownItems, DropdownItemTypes, DropdownStatusIcon } from '../utils';
import { JobType } from 'components/account/jobs/job_type';
import { getRejReasonsNamesAndDescriptions, IdDocumentItemTitle, SELFIE_PENALTY_KEYS } from 'components/account/jobs-v2/dropdowns/IdDocument/utils';
import { IdvError } from 'models/jobs/jobs';
export const ReverificationCompletedResult = ({ jobResult, jobErrors, jobStatus, parentJob, jobRequestInfo, jobRequestProperties, rejectionReasons }) => {
    const selfieConfidence = jobResult.confidences?.selfie;
    const livenessPerformedConfidence = jobResult.confidences?.liveness;
    const faceMatchConfidence = jobResult.confidences?.faceMatch;
    const { dropdownHasWarnings, dropdownHasRejections, dropdownItems } = useMemo(() => {
        const dropdownItemsWithoutIcons = [
            {
                text: IdDocumentItemTitle.ValidSelfie,
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: typeof selfieConfidence === 'number',
                hasErrorOrWarning: itemHasErrorOrWarning(jobErrors, IdvError.InvalidUserPhotoError),
                tooltip: Tooltips.ValidSelfie,
                penalties: getRejReasonsNamesAndDescriptions(rejectionReasons, SELFIE_PENALTY_KEYS)
            },
            {
                text: IdDocumentItemTitle.SelfieLivenessPerformed,
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: typeof livenessPerformedConfidence === 'number',
                hasErrorOrWarning: itemHasErrorOrWarning(jobErrors, IdvError.LivenessSkippedError),
                tooltip: Tooltips.SelfieLivenessPerformed
            },
            {
                text: IdDocumentItemTitle.SelfieMatchesReferenceImage,
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: typeof faceMatchConfidence === 'number',
                hasErrorOrWarning: itemHasErrorOrWarning(jobErrors, IdvError.FaceMatchError),
                tooltip: Tooltips.SelfieMatchesReferenceImage
            }
        ];
        return addIconsToDropdownItems(dropdownItemsWithoutIcons);
    }, [
        jobErrors,
        itemHasErrorOrWarning,
        addIconsToDropdownItems,
        selfieConfidence,
        livenessPerformedConfidence,
        faceMatchConfidence,
        rejectionReasons
    ]);
    const parentParams = parentJob?.request.parameters;
    const parentResult = parentJob?.result;
    const parentProperties = parentJob?.request.properties ?? null;
    const rvDeviceData = buildDeviceData(jobResult, jobRequestInfo);
    const parentDeviceData = buildDeviceData(parentResult, parentJob?.request.requestInfo);
    const submittedData = buildSubmittedData(parentParams);
    const extractedData = parentJob?.request.type === JobType.idVerification && parentResult
        ? buildExtractedData(parentResult)
        : undefined;
    return (React.createElement(Dropdown, { statusIcon: React.createElement(DropdownStatusIcon, { dropdownHasRejections: dropdownHasRejections, dropdownHasWarnings: dropdownHasWarnings, parentJobStatus: jobStatus }), title: "Reverification" },
        React.createElement(Box, null,
            React.createElement(DropdownItemsSection, { dropdownItems: dropdownItems }),
            parentJob && (React.createElement(IDVDetailsTable, { deviceData: parentDeviceData, extractedData: extractedData, header: "Reference Job Details", properties: parentProperties, submittedData: submittedData })),
            React.createElement(IDVDetailsTable, { deviceData: rvDeviceData, header: "Reverification Job Details", properties: jobRequestProperties ?? null }))));
};
